import React from 'react';

const projects = [
  {
    id: 1,
    title: 'ECC Frontend',
    description: 'Investment club dashboard built for a real financial team. Lets members track portfolios, manage installments, handle admin workflows, and view analytics — all through a React + Recharts interface with role-based access and live-ready architecture.',
    category: 'Frontend',
    tags: ['React', 'Vite', 'Recharts', 'Dashboard'],
    github: 'https://github.com/KHUSHPATEL143/ECC-frontend',
    live: 'https://ecc-gamma.vercel.app/',
  },
  {
    id: 2,
    title: 'IdeaForge',
    description: 'AI-powered startup workspace that helps teams evaluate business ideas and manage execution in one place. Covers idea scoring, role-based task management, finance tracking, team chat, Gmail and Google Calendar integration, and a natural-language Command Centre.',
    category: 'Hackathon',
    tags: ['MERN', 'SaaS', 'AI', 'Google Integrations'],
    github: 'https://github.com/KHUSHPATEL143/ideaForge',
    live: 'https://crmideaforge.onrender.com',
  },
  {
    id: 3,
    title: 'Talentra',
    description: 'Multi-agent AI recruitment platform that solves slow, inconsistent hiring. Parses resumes, normalizes skills, and semantically matches candidates to job descriptions — automating recruiter workflows through a FastAPI + LangGraph + ChromaDB pipeline.',
    category: 'Hackathon',
    tags: ['FastAPI', 'LangGraph', 'ChromaDB', 'AI Recruitment'],
    github: 'https://github.com/KHUSHPATEL143/Talentra',
    live: null,
  },
  {
    id: 4,
    title: 'Lakshya',
    description: 'Hackathon winner. An AI browser extension that lets users chat with any webpage, summarize articles and PDFs, explain code, and analyze images — without switching tabs or losing context. Built to keep knowledge workers in their flow.',
    category: 'Hackathon',
    tags: ['AI', 'Browser Extension', '🏆 Winner'],
    github: 'https://github.com/codinggita/team_lakshya',
    live: null,
  },
  {
    id: 5,
    title: 'Attendify',
    description: 'Full-stack MERN school management system for administrators, teachers, and students. Handles attendance tracking, class scheduling, test management, and academic records through secure role-based portals designed for real educational institutions.',
    category: 'Full Stack',
    tags: ['MERN', 'Role-Based Auth', 'School Management'],
    github: 'https://github.com/khushpatel143/attendify',
    live: null,
  },
  {
    id: 6,
    title: 'Vrestro',
    description: 'End-to-end restaurant ordering system built for a real client (Vrundavan). Covers mobile-first customer ordering, a kitchen display screen, manager operations panel, and inventory management — all in one deployable product.',
    category: 'Full Stack',
    tags: ['Restaurant SaaS', 'Mobile-First', 'Kitchen Display'],
    github: 'https://github.com/KHUSHPATEL143/Vrestro',
    live: 'https://restaurant-oc42.vercel.app/',
  },
  {
    id: 7,
    title: 'HTML / CSS / JS Projects & Clones',
    description: 'A portfolio of frontend builds and pixel-perfect clones — including original tools like CodeHub Pro and clones of RedBus, The Souled Store, and a student test portal. Demonstrates UI precision and core web fundamentals without frameworks.',
    category: 'Frontend',
    tags: ['HTML', 'CSS', 'JavaScript', 'UI Clones'],
    github: 'https://github.com/KHUSHPATEL143/Projects_and-_CloneinHTML-CSS-JS',
    live: 'https://projectsandclone.vercel.app/',
  },
];

export default function Projects() {
  return (
    <section id="projects" className="section-shell">
      <div className="container-main">
        <div className="font-mono text-xs tracking-widest uppercase text-text-dim mb-3">03 - Projects</div>
        <h2 className="font-display text-4xl font-extrabold text-text mb-3">Things I Have Built</h2>
        <p className="text-text-muted max-w-xl mb-10">A curated set of hackathon builds, frontend work, and product experiments from my recent work.</p>

        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {projects.map((project) => (
            <div key={project.id} className="card-base p-6 border-accent/10">
              <div className="font-mono text-xs text-accent mb-3">Project {String(project.id).padStart(2, '0')}</div>
              <span className="tag-base mb-3 inline-block">{project.category}</span>
              <h3 className="font-display text-xl font-bold text-text mb-2">{project.title}</h3>
              <p className="text-text-muted text-sm leading-relaxed mb-4">{project.description}</p>
              <div className="flex flex-wrap gap-1.5 mb-5">
                {project.tags.map((tag) => (
                  <span key={tag} className="tag-base">{tag}</span>
                ))}
              </div>
              <div className="flex gap-4">
                <a
                  href={project.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-mono text-xs text-text-muted hover:text-accent transition-colors"
                >
                  Open GitHub Repo
                </a>
                {project.live && (
                  <a
                    href={project.live}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-mono text-xs text-accent hover:text-accent-2 transition-colors"
                  >
                    Live Demo
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-text-muted text-sm mb-4">You can also explore the rest of my work on GitHub.</p>
          <a href="https://github.com/KHUSHPATEL143" target="_blank" rel="noopener noreferrer" className="btn-outline">View GitHub Profile</a>
        </div>
      </div>
    </section>
  );
}
